import { ValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';

export const getFirstValidationErrorMessage = (
	error: Error | ValidationError,
): string | undefined => {
	if (error instanceof ValidationError) {
		const { errors } = error;

		if (!errors || !errors.length) {
			return undefined;
		}

		const [{ error: validationErrorMessage }] = errors;
		return validationErrorMessage;
	}
	return undefined;
};
